import React, { useState, useEffect } from 'react';
import { ClipboardList } from 'lucide-react';
import axios from 'axios';
import { API_URL } from '../config';

const SystemLog = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}?action=get_logs`)
      .then(res => setLogs(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="max-w-4xl">
      <h2 className="text-2xl font-bold text-gray-700 mb-6 flex items-center gap-2">
        <ClipboardList className="text-gray-600" /> System Logs
      </h2>

      <div className="bg-gray-900 text-gray-300 rounded-lg shadow-lg overflow-hidden font-mono text-sm">
        <div className="bg-gray-800 px-6 py-3 text-xs font-bold text-gray-400 uppercase border-b border-gray-700 flex justify-between">
            <span>Action History</span>
            <span>Last 50 Events</span>
        </div>
        <div className="max-h-[500px] overflow-y-auto">
            <table className="min-w-full">
                <tbody>
                    {logs.map((log, index) => (
                        <tr key={index} className="border-b border-gray-800 hover:bg-gray-800/50 transition">
                            <td className="px-6 py-3 text-blue-400 w-48 whitespace-nowrap">{log.timestamp}</td>
                            <td className="px-6 py-3 text-green-400 font-bold w-48">{log.action_type}</td>
                            <td className="px-6 py-3 text-gray-300">{log.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {logs.length === 0 && <div className="p-6 text-center text-gray-600">No logs recorded yet.</div>}
        </div>
      </div>
    </div>
  );
};

export default SystemLog;